import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import GamesSearchModal from "../../../components/GamesSearchModal";
import { altGaming } from "../../../../lib/data/altGaming.data";
import BackIcon from "../../../../assets/svg/BackIcon";

const ALTGaming = () => {
  const navigate = useNavigate();
  const categoriesTab = [
    // { name: "Jili Gaming", key: "jiliGaming" },
    { name: "Mac88 Gaming", key: "mac88Gaming" },
    // { name: "Jili Virtual Gaming", key: "jilivirtual" },
    { name: "Mac88 Virtual Gaming", key: "mac88gamingvirtual" },

    // { name: "Voltent", key: "voltentGaming" },
    // { name: "ICONIC21", key: "iconic21Gaming" },
    // { name: "Turbo Games", key: "turboGaming" },
    // { name: "PGSoft", key: "pgsoftGaming" },
    // { name: "Booming Games", key: "boomingGames" },
    // { name: "Bet Games", key: "betGames" },
    // { name: "Play'n Go", key: "playnGoGaming" },
    // { name: "Playtech Live", key: "playtechliveGaming" },
    // { name: "Smartsoft Gaming", key: "smartsoftGaming" },
  ];
  const [activeCategory, setActiveCategory] = useState("jiliGaming");

  // **Get Games for Active Category**
  const filteredGames = altGaming[activeCategory]
    ? Object.values(altGaming[activeCategory])
    : [];

  console.log("Active Category:", activeCategory);
  console.log("Filtered Games:", filteredGames);

  return (
    <>
    
      <main className="main">
        <div className="prvdr-game-page">
          <div className="heading mt-4">
            <h4>ALT Gaming</h4>
            <div className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </div>
          </div>

          {/* CATEGORY TABS */}
          <ul className="tabs mt-4">
            {categoriesTab.map((tab, index) => (
              <li
                key={index}
                onClick={() => {
                  if (tab?.redirectUrl) {
                    navigate(tab?.redirectUrl);
                  } else {
                    setActiveCategory(tab.key);
                  }
                }}
              >
                <a
                  href="#"
                  className={activeCategory === tab.key ? "active" : ""}
                >
                  {tab.name}
                </a>
              </li>
            ))}
          </ul>

          {/* GAMES LIST */}
          <ul className="gamelisting">
            {filteredGames.length > 0 ? (
              filteredGames.map((game, idx) => (
                <li key={"casinogame" + idx}>
                  <a href={game.redirectUrl}>
                    <img src={game.imgUrl} alt={game.alt} />
                    <div className="providerName">{game.providerName}</div>
                    <div className="GameName">{game.name}</div>
                  </a>
                </li>
              ))
            ) : (
              <p>No games available for this category.</p>
            )}
          </ul>
        </div>
      </main>

    </>
  );
};

export default ALTGaming;
